import React, {Component} from 'react'
import {FormattedMessage, injectIntl} from 'react-intl'
import $ from 'jquery'
import {AppContext} from "@lightspeed-invoicing/core-client/frontend/index";

class EmailModal extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            modalId: this.props.modalId || 'email-modal',
            emailId: this.props.emailId || '',
            subject: '',
            toEmail: '',
            ccEmail: '',
        }
        this.closeModal = this.closeModal.bind(this)
    }

    componentDidMount() {
        $('#' + this.state.modalId).modal('show')
        AppContext.getApiClient().get('/emails/' + this.state.emailId).then(res => {
            this.setState({
                subject: res.attributes.subject,
                toEmail: res.attributes.toEmail,
                ccEmail: res.attributes.ccEmail,
            })
            const doc = document.getElementById(this.state.modalId + '_iframe').contentWindow.document;
            doc.open();
            doc.write(res.attributes.content);
            doc.close();
        })

    }

    closeModal(event) {
        event.preventDefault()
        $('#' + this.state.modalId).modal('hide')
        if (this.props.onClose) {
            this.props.onClose(event)
        }
    }


    render() {
        return (
            <div className="modal fade"
                 id={this.state.modalId}
                 role="dialog"
                 aria-labelledby="emailModalTitle"
                 data-backdrop="static"
                 data-keyboard="false"
            >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title mb-0 pb-0 border-0" id="emailModalTitle">
                                <div className={"h5"}> {this.state.subject}</div>
                                <div className={'w-100'}>
                                    <p className={'m-0 text-secondary'}>
                                        <strong className={'mr-1'}>
                                            <FormattedMessage
                                                id="common.email.modal.to_label"
                                                defaultMessage="To:"
                                            />
                                        </strong>
                                        {this.state.toEmail}
                                    </p>
                                    {this.state.ccEmail ? <p className={'m-0 text-secondary'}>
                                        <strong className={'mr-1'}>
                                            <FormattedMessage
                                                id="common.email.modal.cc_label"
                                                defaultMessage="Cc:"
                                            />
                                        </strong>
                                        {this.state.ccEmail}
                                    </p> : ''}
                                </div>
                            </div>

                            <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <iframe id={this.state.modalId + '_iframe'} width="100%" height="500px" />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" onClick={this.closeModal}>
                                <FormattedMessage
                                    id="common.email.modal.close_btn"
                                    defaultMessage="Close"
                                />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(EmailModal)





// WEBPACK FOOTER //
// ./src/common/email/emailmodal.component.jsx